<body>
  <div class="container-fluid h-100">
    <!--Toaster for success message-->
    <div class="toster success d-flex justify-content-end" *ngIf="showSuccess">
      <div
        class="toster-wrapper ps-3 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center justify-content-between">
          <img width="20" src="../../../assets/icons/tost-success.svg" />
          <div class="content ms-3">
            <h6 class="mb-0">Success</h6>
            <p>{{ successMsg }}</p>
          </div>
        </div>
        <button class="btn" (click)="toastClose()">
          <img width="18" src="../../../assets/icons/ic_close.svg" />
        </button>
      </div>
    </div>
    <!--Toaster for error message-->
    <div class="toster error d-flex justify-content-end" *ngIf="showError">
      <div
        class="toster-wrapper ps-3 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center justify-content-between">
          <img width="20" src="../../../assets/icons/tost-error.svg" />
          <div class="content ms-3">
            <h6 class="mb-0">Error</h6>
            <p>{{ errorMsg }}</p>
          </div>
        </div>
        <button class="btn" (click)="toastClose()">
          <img width="18" src="../../../assets/icons/ic_close.svg" />
        </button>
      </div>
    </div>
    <div
      class="toster success d-flex justify-content-end"
      *ngIf="showProcessing"
    >
      <div
        class="toster-wrapper ps-3 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center justify-content-between">
          <img width="20" src="../../../assets/icons/tost-error.svg" />
          <div class="content ms-3">
            <h6 class="mb-0">Wait</h6>
            <p>{{ processMsg }}</p>
          </div>
        </div>
        <button class="btn" (click)="toastClose()">
          <img width="18" src="../../../assets/icons/ic_close.svg" />
        </button>
      </div>
    </div>

    <!--Toaster for warning message-->
    <div class="toster warning d-flex justify-content-end" *ngIf="showWarning">
      <div
        class="toster-wrapper ps-3 d-flex align-items-center justify-content-between"
      >
        <div class="d-flex align-items-center justify-content-between">
          <img width="20" src="../../../assets/icons/tost-error.svg" />
          <div class="content ms-3">
            <h6 class="mb-0">Warning</h6>
            <p>{{ warningMsg }}</p>
          </div>
        </div>
        <button class="btn" (click)="toastClose()">
          <img width="18" src="../../../assets/icons/ic_close.svg" />
        </button>
      </div>
    </div>

    <!-- QZ Tray Permission Modal -->
    <div
      class="qz-permission-backdrop"
      *ngIf="showQzPermissionModal"
      (click)="closeQzModal()"
    ></div>
    <div
      class="qz-permission-modal"
      *ngIf="showQzPermissionModal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="qz-permission-title"
    >
      <div class="qz-permission-modal__header">
        <div class="qz-permission-modal__icon" aria-hidden="true">
          <span class="material-icons">print</span>
        </div>
        <h5 id="qz-permission-title" class="qz-permission-modal__title">
          Printer access blocked
        </h5>
        <button
          class="qz-permission-modal__close"
          type="button"
          (click)="closeQzModal()"
          aria-label="Close"
        >
          <img width="18" src="../../../assets/icons/ic_close.svg" />
        </button>
      </div>
      <div class="qz-permission-modal__body">
        <div class="qz-permission-modal__content">
          <p class="qz-permission-modal__message">{{ qzPermissionMsg }}</p>
          <div class="qz-permission-steps">
            <p class="qz-permission-steps__label">TO FIX THIS</p>
            <div class="qz-permission-step">
              <span class="qz-permission-step__number">1</span>
              <p>
                Click the <strong>lock / info icon</strong> in the browser
                address bar
              </p>
            </div>
            <div class="qz-permission-step">
              <span class="qz-permission-step__number">2</span>
              <p>
                Go to <strong>Site settings</strong> &nbsp;<span
                  aria-hidden="true"
                  >&rarr;</span
                >&nbsp;
                <strong>Local network access, Apps on Device</strong> and set it
                to <strong>Allow</strong>
              </p>
            </div>
            <div class="qz-permission-step">
              <span class="qz-permission-step__number">3</span>
              <p>Reload the page</p>
            </div>
          </div>
        </div>
      </div>
      <div class="qz-permission-modal__footer">
        <button
          class="btn modal-btn add-btn"
          type="button"
          (click)="reloadPage()"
        >
          Reload page
        </button>
      </div>
    </div>

    <router-outlet></router-outlet>
  </div>
  <div id="google_translate_element" style="display:none"></div>
</body>